import React from "react";
import "./LogoutModal.css";

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogout: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onClose,
  onLogout,
}) => {
  if (!isOpen) return null;

  return (
    <div className="logout-modal-overlay">
      <div className="logout-modal-content">
        <button className="logout-modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="logout-modal-title">Log Out</h2>
        <p className="logout-modal-message">
          Are you sure you want to log out?
        </p>
        <div className="logout-modal-actions">
          <button
            className="logout-modal-btn logout-modal-btn--cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="logout-modal-btn logout-modal-btn--logout"
            onClick={onLogout}
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
